import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";

import misionImg from "../../static/media/nosotros/Mision.webp";
import visionImg from "../../static/media/nosotros/Vision.webp";

const C = {
  dark: "#0C1F2F",
  navy: "#0057A8",
  navyDark: "#003D73",
  gold: "#FFCD00",
  teal: "#5BC8AF",
  gray: "#F5F7FA",
  white: "#ffffff",
};

const CARDS = [
  {
    title: "Nuestra Misión",
    accentColor: C.navy,
    img: misionImg,
    text: "ELECTRICAGRM es una empresa innovadora en soluciones de ingeniería y desarrollos eléctricos; confiables, eficientes y éticos, orientada a satisfacer las necesidades y aspiraciones de nuestros clientes desarrollándolas al más alto nivel de excelencia, economía y eficiencia, manteniendo estándares de calidad e integrando nuevos y mejores productos.",
  },
  {
    title: "Nuestra Visión",
    accentColor: C.gold,
    img: visionImg,
    text: "Constituirnos en una empresa líder de ingeniería, con capacidad para enfrentar nuevos desafíos y aportar soluciones innovadoras y efectivas, que se encuentren dirigidas al crecimiento y desarrollo productivo tanto local como nacional, consolidándonos como un aliado estratégico en búsqueda de la satisfacción del cliente.",
  },
];

export default function MisionVision() {
  return (
    <Box
      sx={{
        // Aplicamos el gradiente azul oscuro aquí
        background: `linear-gradient(180deg, ${C.navy} 0%, ${C.navyDark} 100%)`,
        pt: { xs: "64px", md: "88px" },
        pb: 0,
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          maxWidth: "1280px",
          mx: "auto",
          px: { xs: "20px", sm: "32px", md: "40px" },
          boxSizing: "border-box",
          width: "100%",
        }}
      >
        <Box
          component={motion.div}
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          sx={{ mb: { xs: 5, md: 8 }, textAlign: "center" }}
        >
          <Typography
            variant="h2"
            sx={{
              // Título en blanco para contrastar con el fondo azul
              color: C.white,
              fontWeight: 900,
              fontSize: { xs: 28, sm: 34, md: 42 },
              letterSpacing: "-.02em",
              lineHeight: 1.1,
            }}
          >
            Misión y Visión
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: "24px", md: "32px" },
          }}
        >
          {CARDS.map((card, i) => (
            <Box
              key={card.title}
              component={motion.div}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.55, delay: i * 0.12 }}
              whileHover={{ y: -6, transition: { duration: 0.22 } }}
              sx={{
                flex: 1,
                background: C.white,
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 10px 30px rgba(0,0,0,.25)",
              }}
            >
              <Box sx={{ height: "5px", background: card.accentColor }} />

              <Box sx={{ p: { xs: "28px 22px", md: "36px 32px" } }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "16px",
                    mb: 3,
                  }}
                >
                  <Box
                    sx={{
                      width: 56,
                      height: 56,
                      borderRadius: "14px",
                      background: `${card.accentColor}16`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      flexShrink: 0,
                    }}
                  >
                    <Box
                      component="img"
                      src={card.img}
                      alt={card.title}
                      sx={{ width: 48, height: 48, objectFit: "contain" }}
                    />
                  </Box>
                  <Typography
                    sx={{
                      color: C.dark,
                      fontWeight: 900,
                      fontSize: { xs: 20, md: 24 },
                      letterSpacing: "-.01em",
                      lineHeight: 1.15,
                    }}
                  >
                    {card.title}
                  </Typography>
                </Box>

                <Typography
                  sx={{
                    color: "#4e5f6e",
                    fontSize: { xs: 14, md: 15 },
                    lineHeight: 1.85,
                  }}
                >
                  {card.text}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Box>

      {/* Unión conectando con NuestroEquipo (blanco) */}
      <Box
        sx={{
          height: { xs: "120px", md: "180px" },
          background: `linear-gradient(180deg, ${C.navyDark} 0%, ${C.white} 100%)`,
          mt: { xs: 7, md: 10 },
        }}
      />
    </Box>
  );
}
